<template>
	<div class="huizhong-fenxi">
		<!-- 总体情况汇总分析 -->
		<div class="huizhong-fenxi-box">
			<div>
				<span>总体情况汇总</span>
			</div>
			<div class="fenxi-table">
				<div class="table-desc" v-if="examRange == 2">
					<div>联考总分基本情况</div>
				</div>
				<div class="grade-table" v-if="examRange == 2">
					<tables :tableOptions="exminationData"></tables>
				</div>
				<div class="table-desc">
					<div>总分基本情况</div>
				</div>
				<div class="grade-table">
					<tables :tableOptions="totalGradeData"></tables>
				</div>
				<div class="table-desc">
					<div>各学科基本数据对比情况</div>
					<!-- <el-button type="info" size="mini">下载表格</el-button> -->
				</div>
				<div class="grade-table">
					<tables :tableOptions="subjectGradeData"></tables>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {
		tables: () => import('hm-table')
	},
	props: {
		totalGradeData: {
			type: Array,
			default: () => [],
			required: true
		},
		subjectGradeData: {
			type: Array,
			default: () => [],
			required: true
		},
		examRange: {
			type: Number
			// default: () => []
			// required: true
		},
		exminationData: {
			type: Array,
			default: () => []
			// required: true
		}
	},
	data() {
		return {
			newTotalGradeData: [],
			newFlag: true
		}
	},
	created() {},
	mounted() {},
	methods: {}
}
</script>
<style lang="less" scoped>
.huizhong-fenxi {
	//margin: 10px 0px;
	padding: 30px;
	height: auto;
	background-color: #fff;
	border: 1px solid #ebeef5;
	border-radius: 3px;
	transition: 0.3s;
	.huizhong-fenxi-box {
		> div:nth-child(1) {
			> span {
				font-weight: bold;
			}
		}
		height: auto;
		// background-color: skyblue;
		div {
			margin-bottom: 7px;
		}
		& > div > span:nth-child(1) {
			font-size: 18px;
		}
		.fenxi-table {
			height: auto;
			.table-desc {
				margin-top: 20px;
				display: flex;
				& > div:nth-child(1) {
					flex-grow: 1;
				}
			}
			.grade-table {
				// width: 98%;
				.el-table {
					/deep/.cell {
						text-align: center;
					}
				}
			}
		}
	}
	&:hover {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}
}
</style>
